import propTypes from "prop-types";
import LogoImg from "../assets/logo_BCHtagline.svg";

const Footer = (props) => {
  
console.log("In Footer:", props);
  
  return (
    <div className="footer">
      <img src={LogoImg} alt="BCH Logo" />
      <div>{props.applicationName}</div>
      <div>
        {/* this need pass in the version and link */}
        <a href={props.versionLink}>Version {props.version}</a> &copy; 2021 All Rights
        Reserved
      </div>
    </div>
  );
};

// in case nothing is passed in
Footer.defaultProps = {
  version: "Version 1.0"
};
// in case nothing is passed in
Footer.defaultProps = {
  versionLink: "https://www.childrenshospital.org/"
};

// set version type to string, and make it required
Footer.propTypes = {
  version: propTypes.string.isRequired
};
// set versionLink type to string, and make it required
Footer.propTypes = {
  versionLink: propTypes.string.isRequired
};

export default Footer;
